import React from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import di from "../di/index";
import { ECurrentLoginComponent } from "@domains/salesFeatures/Login/entities/iLogin";
import { ERole } from "../Login";
var BackToLogin = function () {
    return (React.createElement("div", { className: "back-to-login-btn-container" },
        React.createElement(EdButton, { value: "Back to Login", btnTyp: "midnight-blue-underline", className: "back-to-login-btn", onClick: function () {
                di.login.changeCurrentLoginComponent({
                    currentComponent: ECurrentLoginComponent.RM_PARTNER_LOGIN_TABS,
                    extraConfig: {
                        currentActiveTab: ERole.Partner,
                    },
                });
            } })));
};
export default BackToLogin;
